import {isNativeWebView as isNative} from './isNativeWebView';
import {canInstallApp} from './canInstallApp';
import {updateWidget} from './updateWidget';
import {sendMessage} from './sendMessage';

export const iosDevice: DeviceService = {
  sendMessage,
  updateWidget,
  canInstallApp,
  isNative,
};
